import { navigateTo } from "../../../../../navigationService/navigationServiceFunctions"

export async function handleFeatureWeatherStation(feature: any) {
    const id = feature?.properties?.id
    if (id != null) navigateTo(`/app/weatherStations/${id}`)
}